import { SVGProps } from 'react';

const ListMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 12H3m13-6H3m13 12H3m18-6h-6"
    />
  </svg>
);
export default ListMinus;
